module.exports = __webpack_public_path__ + "img/laine-kollane.55540f80.svg";